/* eslint camelcase: 0 */
/* eslint @typescript-eslint/no-unsafe-return: 0 */


const PageTitleDefaults = {
  create: 'Добавить',
  edit: 'Редактировать',
  view: '«{name}»',
  list: 'Список',
}

const ModalDeleteDefaults = {
  delete: 'Удаление «{name}»',
  delete_all: 'Удаление выбранных',
  delete_all_partly: 'Удаление части выбранных',
}

const ResponseSuccessDefaults = {
  create: 'Сведения добавлены',
  update: 'Сведения обновлены',
  delete: 'Сведения удалены',
  delete_all: 'Выбранные сведения удалены',
  delete_all_deny: 'Выбранные сведения нельзя удалить',
}

const ResponseErrorDefaults = {
  create: 'Ошибка создания сведений',
  read: 'Ошибка загрузки сведений',
  read_all: 'Ошибка загрузки сведений',
  update: 'Ошибка обновления сведений',
  delete: 'Ошибка удаления сведений',
  delete_all: 'Ошибка удаления сведений',
}

/**
 * @template {{ readonly [key: string]: string |((data = {}) => string) }} T
 * @param {T} messages
 * @returns {{ [K in keyof T]: T[K] extends string ? T[K] : ReturnType(T[K]) }}
 */

interface Messages<T> {
  readonly [key: string]: string | ((data: T) => string);
}

type MessagesMap<M> = {
  [K in keyof M]: M[K] extends string
    ? M[K]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : M[K] extends (d: any) => string
      ? ReturnType<M[K]>
      : never
}

export const createMessages = <T = never, M = Messages<T>>(messages: M, data?: T): MessagesMap<M> => (
  (Object.keys(messages) as Array<keyof M>).reduce((acc, key) => {
    const value = messages[key]
    if (typeof value === 'string' || !data) {
      const attributes = { value, enumerable: true }
      Object.defineProperty(acc, key, attributes)
    } else if (typeof value === 'function') {
      const attributes = { get: () => value(data), enumerable: true }
      Object.defineProperty(acc, key, attributes)
    }

    return acc

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  }, {} as MessagesMap<M>)
)

export class Model<T> {
  public static readonly page_title = createMessages(PageTitleDefaults);

  public static readonly modal_delete = createMessages(ModalDeleteDefaults);

  public static readonly response_success = createMessages(ResponseSuccessDefaults);

  public static readonly response_error = createMessages(ResponseErrorDefaults);

  public readonly page_title: typeof PageTitleDefaults;

  public readonly modal_delete: typeof ModalDeleteDefaults;

  public readonly response_success: typeof ResponseSuccessDefaults;

  public readonly response_error: typeof ResponseErrorDefaults;

  constructor(
    private readonly data: T,
  ) {
    // @ts-ignore: как-то
    const constructor = this.constructor as Model<T>

    this.page_title = createMessages<this, typeof Model['page_title']>(constructor.page_title, this)
    this.modal_delete = createMessages<this, typeof Model['modal_delete']>(constructor.modal_delete, this)
    this.response_success = createMessages<this, typeof Model['response_success']>(constructor.response_success, this)
    this.response_error = createMessages<this, typeof Model['response_error']>(constructor.response_error, this)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getId<D = any>(data: D | any): string | number {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return data?.id ?? '...'
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getName<D = any>(data: D | any): string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return data?.name ?? '...'
  }

  public get id() {
    // @ts-ignore: TODO static
    const getId = this.constructor.getId as typeof Model['getId']
    return getId(this.data)
  }

  public get name() {
    // @ts-ignore: TODO static
    const getName = this.constructor.getName as typeof Model['getName']
    return getName(this.data)
  }
}
